import { ChangeDetectionStrategy, Component, Input } from "@angular/core";

@Component({
    selector: "app-loading-indicator",
    templateUrl: "./loading_indicator.component.html",
    styleUrls: ["./loading_indicator.component.css"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoadingIndicatorComponent {
    @Input() message = "Loading...";

    protected readonly logoPath = "assets/images/logo/logo_icon.png";
}
